export function GetFundPrefix(fundValue: number | undefined) {
  if (!fundValue || fundValue < 0) return "";
  return "+";
}
